import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import { FiLayers, FiUsers, FiActivity } from 'react-icons/fi';

export default function SuperAdminLogin() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await api.post('/superadmin/auth/login', form);
      toast.success('Welcome, Super Admin');
      navigate('/superadmin/dashboard');
    } catch (err) {
      setError(err.response?.data?.msg || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      {/* Left Brand Panel */}
      <div className="login-brand-panel">
        <div className="login-shape login-shape-1" />
        <div className="login-shape login-shape-2" />
        <div className="login-shape login-shape-3" />
        <div className="login-brand-content">
          <div className="login-brand-logo">AC</div>
          <h2>Command Center</h2>
          <p>Manage all workspaces, monitor system health, and oversee the entire AffixCenter platform.</p>
          <div className="login-brand-features">
            <div className="login-brand-feature">
              <div className="login-brand-feature-icon"><FiLayers /></div>
              <span>Multi-workspace management</span>
            </div>
            <div className="login-brand-feature">
              <div className="login-brand-feature-icon"><FiUsers /></div>
              <span>Global user administration</span>
            </div>
            <div className="login-brand-feature">
              <div className="login-brand-feature-icon"><FiActivity /></div>
              <span>System-wide analytics</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Form Panel */}
      <div className="login-form-panel">
        <div className="login-container">
          <div className="login-header">
            <div className="login-welcome-tag">Super Admin</div>
            <h1>Access Console</h1>
            <p>Authenticate to manage the platform</p>
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label className="form-label">Username</label>
              <input type="text" className="form-input" placeholder="Enter username" value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })} required />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <input type="password" className="form-input" placeholder="Enter password" value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })} required autoComplete="current-password" />
            </div>
            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Authenticating...' : 'Access Console'}
            </button>
          </form>

          <div className="login-footer-link">
            <a href="/login">← Back to Portal Login</a>
          </div>
        </div>
      </div>
    </div>
  );
}
